<fin-mmb-unsaved-changes
  [unsavedChangesModalOpen]="unsavedChangesModalOpen"
  (leaveWithoutSaving)="leaveWithoutSaving()"
  (continueEditing)="continueEditing()"
></fin-mmb-unsaved-changes>
<ul *ngIf="booking$ | async as booking" class="unstyled">
  <li
    *ngFor="let pax of booking.passengers; index as paxIndex"
    class="pr-small rounded-large border mr-medium-b white-bg"
    data-testid="mmb-pax-details-passenger-info"
  >
    <h2 class="font-heading-4 nordic-blue-900-text mr-small-b">
      {{ 'paxDetails.passenger' | finLocalization | titlecase }} {{ paxIndex + 1 }}
    </h2>

    <fin-mmb-passenger-info
      (formDirtyStatus)="setPassengerDirtyStatus(pax.id, $event)"
      class="block"
      [paxIndex]="paxIndex + 1"
      [passenger]="pax"
      [passengers]="booking.passengers"
      [controlData$]="controlData$"
      [isMainPax]="(mainPaxInfo$ | finMap: 'id' | async) === pax.id"
      [accompanyingAdult]="getAccompanyingAdult(pax) | async"
      [accompanyingInfant]="getAccompanyingInfant(pax) | async"
      [isSaving$]="updatingPassengers.includes(pax.id) | finToObservable"
      [allFrequentFlyerCards$]="allFrequentFlyerCards$"
      (paxDetailsUpdating)="setUpdatingPassenger(pax.id, $event)"
    >
    </fin-mmb-passenger-info>

    <fin-included-product-item
      class="block mr-small-t pr-small-t border-top-dashed"
      [includePaddings]="false"
      [category]="'tickets'"
      [buttonTranslationKey]="'MMB.labels.documentsTitle'"
      [disabled]="updatingPassengers.includes(pax.id)"
    >
      <fin-mmb-passenger-tickets
        *ngIf="pax.etickets && pax.etickets.length > 0"
        [tickets]="pax.etickets"
        class="mr-small-t pr-small-t"
      ></fin-mmb-passenger-tickets>

      <fin-mmb-passenger-emds [emds]="pax.emds" class="mr-small-t pr-small-t"></fin-mmb-passenger-emds>
      <fin-mmb-passenger-order-eticket></fin-mmb-passenger-order-eticket>
    </fin-included-product-item>

    <ng-container *ngIf="passengerTierData$ | finMap: pax.id | async as passengerTierData">
      <fin-included-product-item
        class="block mr-small-t pr-small-t border-top-dashed"
        category="tier"
        [includePaddings]="false"
        [buttonTranslationKey]="passengerTierData.tierLabel"
        [disabled]="updatingPassengers.includes(pax.id)"
        data-testid="mmb-pax-details-included-tier-benefit"
      >
        <fin-mmb-tier-benefits
          [tier]="getFinnairPlusTier(pax.frequentFlyerCards)"
          [tierBenefits]="passengerTierData.benefits"
        >
        </fin-mmb-tier-benefits>
      </fin-included-product-item>
    </ng-container>
  </li>
  <li
    data-testid="mmb-pax-details-emergency-contact"
    *ngIf="!booking.otherInformation.isGroupBooking"
    class="pr-small rounded-large mr-medium-b border white-bg"
  >
    <h2 class="font-heading-4 nordic-blue-900-text mr-small-b">
      {{ 'MMB.labels.emergencyContactDetails' | finLocalization }}
    </h2>

    <fin-mmb-emergency-contact
      (formDirtyStatus)="setEmergencyContactDirtyStatus($event)"
      class="block"
      [emergencyContact]="emergencyContact$ | async"
    ></fin-mmb-emergency-contact>
  </li>
</ul>
